import React, { useContext, useState, useEffect } from 'react';
import * as style from "./Modals.module.css"

export const InfoModal = ({ onAccept }) => {
  const [ state, setState ] = useState(0)

  useEffect(()=>{
    console.log("")
  }, [])

  return (
    <ModalContainer>
      <div style={{ flex: 2 }}>
      <p>Hello there!</p></div>
      <div style={{ flex: 1 }}><button onClick={ onAccept }>Ok!</button></div>
    </ModalContainer>
  )
}

export const WarningModal = ({ onAccept }) => {
  const [ state, setState ] = useState(0)

  useEffect(()=>{
    console.log("")
  }, [])

  return (
    <ModalContainer>
      <div style={{ flex: 2 }}>
      <p>Warning there!</p></div>
      <div style={{ flex: 1 }}><button onClick={ onAccept }>Ok!</button></div>
    </ModalContainer>
  )
}

export const ErrorModal = ({ onAccept }) => {
  const [ state, setState ] = useState(0)

  useEffect(()=>{
    console.log("")
  }, [])

  return (
    <ModalContainer>
      <div style={{ flex: 2 }}>
      <p>Error there!</p></div>
      <div style={{ flex: 1 }}><button onClick={ onAccept }>Ok!</button></div>
    </ModalContainer>
  )
}


const ModalContainer = ({ children }) => {
  return (
    <div className={style.container}>
      <div className={style.item} style={{ display: "block" }}>
        <div className={style.popup}>
          {children}
        </div>
      </div>
    </div>
)
}
